document.addEventListener("DOMContentLoaded", function () {
  const currency = window.Shopify?.currency?.active || "EUR";

  function getCartValue() {
    const totalSpan = document.querySelector(".cart_totals-value");
    if (!totalSpan) return 0;
    return parseFloat(totalSpan.textContent.trim().replace(/[€\s]/g, "").replace("EUR", "").replace(",", ".")) || 0;
  }

  function getProductDataByVariantId(variantId) {
    const script = document.querySelector(`[data-product-data][data-variant-id="${variantId}"]`);
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  async function extractProductId(variantId, productData) {
    let pId = productData?.product_id || productData?.featured_image?.product_id;
    if (!pId && productData?.variants) pId = productData.id;
    if (pId) return String(pId);

    try {
      const variantInput = document.querySelector(`input[name="id"][value="${variantId}"], select[name="id"] option[value="${variantId}"]`);
      if (variantInput) {
        const form = variantInput.closest('form');
        if (form) {
          const productInput = form.querySelector('input[name="product-id"], input[name="product_id"]');
          if (productInput && productInput.value) return String(productInput.value);
        }
      }
    } catch(e) {}

    try {
      const res = await fetch('/cart.js');
      const cartData = await res.json();
      if (cartData && cartData.items) {
        const cartItem = cartData.items.find(item => item.variant_id.toString() === variantId.toString());
        if (cartItem && cartItem.product_id) return String(cartItem.product_id);
      }
    } catch(e) {}

    if (window.meta?.product?.id) return String(window.meta.product.id);
    if (window.ShopifyAnalytics?.meta?.product?.id) return String(window.ShopifyAnalytics.meta.product.id);

    if (window.location.pathname.includes('/products/')) {
      try {
        const res = await fetch(window.location.pathname.split('?')[0] + '.js');
        const data = await res.json();
        if (data.id) return String(data.id);
      } catch(e) {}
    }

    return "undefined";
  }

  async function pushEventToDataLayer(eventName, variantId, quantity) {
    const productData = getProductDataByVariantId(variantId);
    if (!productData) return;

    const finalPrice = productData.price / 100;
    const maxPrice = productData.compare_at_price ? productData.compare_at_price / 100 : finalPrice;
    const discount = Math.max(0, maxPrice - finalPrice);
    const cartValue = getCartValue();

    const productId = await extractProductId(variantId, productData);
    const itemId = (productId !== "undefined" && productId != null) ? `shopify_ZZ_${productId}_${variantId}` : `shopify_ZZ_undefined_${variantId}`;

    const eventData = {
      event: eventName,
      ecommerce: {
        currency: currency,
        value: cartValue,
        items: [{
            item_name: productData.title,
            item_id: itemId,
            price: finalPrice,
            item_brand: productData.vendor,
            quantity: quantity,
            discount: discount,
          }]
      }
    };

    if (eventName === "remove_from_cart") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(eventData);
    }
  }

  document.body.addEventListener("click", function (e) {
    const plusBtn = e.target.closest('button[name="increment"]');
    const minusBtn = e.target.closest('button[name="decrement"]');
    const removeBtn = e.target.closest('a[is="cart-remove-item"], a.btn-remove, cart-remove-button a, a.button--tertiary[aria-label*="remove"], a.button--tertiary[aria-label*="Remove"]');

    if (plusBtn) {
      const wrapper = plusBtn.closest("quantity-input") || plusBtn.closest("tr.cart-item");
      if (!wrapper) return;
      const input = wrapper.querySelector(".quantity__input");
      if (input?.dataset.quantityVariantId) pushEventToDataLayer("add_to_cart", input.dataset.quantityVariantId, 1);
      return;
    }

    if (minusBtn) {
      const wrapper = minusBtn.closest("quantity-input") || minusBtn.closest("tr.cart-item");
      if (!wrapper) return;
      const input = wrapper.querySelector(".quantity__input");
      if (input?.dataset.quantityVariantId) pushEventToDataLayer("remove_from_cart", input.dataset.quantityVariantId, 1);
      return;
    }

    if (removeBtn) {
      const tr = removeBtn.closest("tr.cart-item") || removeBtn.closest(".cart-item");
      if (!tr) return;
      const input = tr.querySelector(".quantity__input");
      let quantity = input && input.value ? parseInt(input.value, 10) || 1 : 1;
      if (input?.dataset.quantityVariantId) pushEventToDataLayer("remove_from_cart", input.dataset.quantityVariantId, quantity);
      return;
    }
  });
});